export const errorsAgent: {
    [index: string]: {
        title: string
        description?: string
    }
} = {
    '1001': {
        title: 'Preenchimento incorreto',
        description: 'É necessário preencher todos os campos obrigatórios'
    },
    '1002': {
        title: 'Algo deu errado',
        description: 'Tente novamente'
    },
    '1003': {
        title: 'Código expirado',
        description: 'Solicite uma nova senha'
    },
    '1004': {
        title: 'Tempo de resposta excedido',
        description: 'Tente novamente'
    },
    '1005': {
        title: 'Ops, você não deveria estar aqui'
    },
    '1006': {
        title: 'Algo deu errado',
        description: 'Tente novamente'
    },
    '1007': {
        title: 'Agente cadastrado anteriormente',
        description: 'Verifique o CNPJ e tente novamente'
    },
    '1008': {
        title: 'Instituição não encontrada',
        description: 'Cadastre uma nova instituição financeira'
    },
    '1009': {
        title: 'Agente não encontrado',
        description: 'Cadastre um novo agente financeiro'
    },
    '1010': {
        title: 'Preenchimento incorreto',
        description: 'Verifique o código do agente financeiro'
    },
    '1011': {
        title: 'Preenchimento incorreto',
        description: 'Verifique o código e tente novamente'
    },
    '1012': {
        title: 'DETRAN não encontrado',
        description: 'Cadastre um novo DETRAN'
    },
    '1013': {
        title: 'Agente cadastrado anteriormente ',
        description: 'Verifique o código e tente novamente'
    }
}
